<script>
// Root component — must use Options API (not <script setup>) because Vue's
// in-DOM template resolution requires a component with no render function.
// The server-rendered HTML inside #app is used as the template.
export default {}
</script>
